var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcCheckboxRadioSwitch',{attrs:{"checked":_vm.croppedLayout,"type":"switch"},on:{"update:checked":_vm.updateSetting}},[_vm._v("\n\t"+_vm._s(_vm.t('photos', 'Enable squared photos view'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }